var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovSeo = function SvgCovSeo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102.644,
    height: 102.64,
    viewBox: "0 0 102.644 102.64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-715.424 -1032.379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.381,1113.42a8.459,8.459,0,0,1-6.024-2.486l-18.063-18.077,1.273-1.272,18.063,18.077a6.71,6.71,0,1,0,9.49-9.487l-13.141-13.155,1.273-1.272,13.139,13.153a8.5,8.5,0,0,1-6.011,14.52Z",
    transform: "translate(20.177 21.6)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.145,1085.505h-7.309v-1.8h5.509v-12.49h-5.28l-.125-.752a40.437,40.437,0,0,0-6.735-16.5l-.431-.618,3.656-3.656-8.832-8.831-3.617,3.615-.62-.44a32.673,32.673,0,0,0-8.3-4.406l-.843-.316.631-1.686.843.316a33.866,33.866,0,0,1,8.085,4.188l3.818-3.816,11.377,11.376-3.867,3.867a42.225,42.225,0,0,1,6.475,15.86h5.562Z",
    transform: "translate(17.919 2.239)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.433,1109.115h-16.09v-7.52h1.8v5.72h12.49v-5.577l.746-.129a40.726,40.726,0,0,0,30.654-24.654l.341-.833,1.666.683-.341.833a42.53,42.53,0,0,1-31.265,25.608Z",
    transform: "translate(11.356 17.904)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.458,1108.446l-.849-.3a42.341,42.341,0,0,1-9.513-4.777l-4.123,4.122L723.6,1096.114l4.075-4.075a42.214,42.214,0,0,1-6.582-15.651h-5.665V1060.3h7.217v1.8h-5.417v12.49h5.363l.133.741a40.426,40.426,0,0,0,6.853,16.292l.441.62-3.873,3.873,8.832,8.832,3.911-3.91.618.431a40.555,40.555,0,0,0,9.705,4.982l.849.3Z",
    transform: "translate(0 11.356)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.228,1065.942l-1.709-.566.283-.854a30.555,30.555,0,0,1,4.487-8.731l-3.862-3.863,11.377-11.376,3.819,3.817a42.227,42.227,0,0,1,15.907-6.632v-5.357h16.09v7.008h-1.8v-5.208H754.33v5.065l-.746.129a40.434,40.434,0,0,0-16.543,6.9l-.62.44L732.8,1043.1l-8.832,8.831,3.654,3.655-.431.618a29.9,29.9,0,0,0-4.685,8.886Z",
    transform: "translate(2.169)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.174-.9A32.082,32.082,0,0,1,43.659,60.727,32.082,32.082,0,0,1,18.689,1.621,31.874,31.874,0,0,1,31.174-.9Zm0,62.348A30.282,30.282,0,0,0,42.958,3.279,30.282,30.282,0,0,0,19.39,59.07,30.084,30.084,0,0,0,31.174,61.448Z",
    transform: "translate(731.57 1048.268)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(745.168 1086.746)",
    fill: "#183149",
    fontSize: 20,
    fontFamily: "BaiJamjuree-Medium, Bai Jamjuree",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEO")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovSeo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-seo.c5bd8c58.svg";
export { ForwardRef as ReactComponent };